import React from 'react'
import { CustomCol } from 'src/components'
import { useTranslation } from 'next-i18next'
import { Divider, Row, Col, Button } from 'antd'
import { useAppDispatch, useAppSelector } from 'src/app/hooks'
import { ArrowLeftOutlined, ArrowRightOutlined } from '@ant-design/icons'
import { completeInfoSubmitSelector, setCompleteRegisterFormValue } from 'src/features'

interface RegisterCompleteStepChangerProps {
  nextStepValue: number,
  beforeStepValue?: number,
  handleSubmitClick?: () => void
}

const RegisterCompleteStepChanger: React.FC<RegisterCompleteStepChangerProps> = (props) => {
  const { t } = useTranslation()
  const dispatch = useAppDispatch()
  const { nextStepValue, beforeStepValue = null, handleSubmitClick = null } = props
  const { loading: loadingSubmit } = useAppSelector(completeInfoSubmitSelector)

  const buttonLabel = {
    next: t('card.Continue'),
    loading: t('Auth.CompleteInfo.Completing'),
    no_loading: t('Auth.CompleteInfo.Complete')
  }[beforeStepValue !== 2 ? 'no_loading' : loadingSubmit ? 'loading' : 'no_loading']

  return (
    <>
      <Divider />
      <Row>
        {nextStepValue !== 3 ? <CustomCol xs={12}>
          <Button
            type='default'
            className='radius-100 fade-animation'
            icon={<ArrowLeftOutlined />}
            size={'large'}
            onClick={() => dispatch(setCompleteRegisterFormValue({ key: 'step', value: beforeStepValue }))}
          >
            {t('card.Back')}
          </Button>
        </CustomCol> : <Col xs={12} lg={12} />}

        <CustomCol xs={12}>
          {handleSubmitClick ? <Button
            type='primary'
            htmlType='button'
            className='float-right radius-100 '
            icon={<ArrowRightOutlined />}
            onClick={handleSubmitClick}
            size={'large'}
          >
            {t('card.Continue')}
          </Button> : <Button
            type='primary'
            htmlType='submit'
            className='float-right radius-100'
            loading={loadingSubmit}
            icon={beforeStepValue !== 2! && <ArrowRightOutlined />}
            size={'large'}
          >
            {buttonLabel}
          </Button>
          }
        </CustomCol>
      </Row>
    </>
  )
}

export default RegisterCompleteStepChanger
